import React from "react";
import Line from "../../../assets/line2.svg";
import MainImg from "../../../assets/illustrations2/PNG/extension_page_v-a_searches_into_sheets.png";

export default function TestimonialTwo() {
  return (
    <div>
      <h2 className="text-3xl bg-gray-50 pt-8 sm:text-4xl lg:text-[3rem] lg:leading-[3.5rem] font-bold text-center md:pt-14">
        Turn Sales{" "}
        <span className="relative inline-block">
          Navigator{" "}
          <img
            src={Line}
            alt="Underline decoration"
            className="absolute bottom-0 left-0 w-full top-9 lg:top-[47px]"
          />
        </span>{" "}
      </h2>
      <h2 className="text-3xl bg-gray-50 sm:text-4xl lg:text-[3rem] lg:leading-[3.5rem] font-bold text-center">
        Results into Spreadsheets
      </h2>
      <div className="bg-gray-50 p-8 lg:px-20">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8">
          <div
            className={`flex justify-center items-center mt-8 md:mt-0 md:w-[45%] md:order-1`}
          >
            <img
              src={MainImg}
              alt="Expanded section preview"
              className="md:w-full w-96"
            />
          </div>

          <div className={`text-left md:w-[55%] md:order-2 lg:mt-10 md:p-6`}>
            <p className="text-[22px] my-6 lg:mb-12">
              Simplify lead generation by turning your Sales Navigator searches
              into organized contact lists. Extract information, sort it, and
              use it right away. Save time and improve your outreach with
              better-organized leads.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
